<template>
  <div class="text-xs-center">
    <v-dialog v-model="shown"
      max-width="700"
      persistent
    >
      <v-card>
        <v-card-title class="headline grey lighten-2"
          primary-title
        >
          {{ title }}
        </v-card-title>

        <v-card-text>

          <v-form ref="form">
            <v-container grid-list-md>
              <v-flex xs12>
                  <v-text-field v-model="fields.email"
                    label="Login"
                    type="email"
                    :rules="rules.email"
                    required></v-text-field>
              </v-flex>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field v-model="fields.first_name"
                    label="First Name"
                    :rules="rules.first_name"
                    required></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="fields.last_name"
                    label="Last Name"
                    :rules="rules.last_name"
                    required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="$store.getters['entitlements/roles']"
                    item-text="name"
                    item-value="id"
                    v-model="fields.role_id"
                    :rules="[v => !!v || 'Please select a role']"
                    label="Role"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="authenticationType" row>
                     <template v-slot:label>
                      <div>Authentication:</div>
                    </template>
                    <v-radio key="authenticationType-cognito"
                            label="Single Sign On"
                            value="sso"/>
                    <v-radio key="authenticationType-password"
                            label="Password"
                            value="password"/>
                  </v-radio-group>
                  <v-text-field v-model="fields.password"
                    v-show="showPassword"
                    label="Password"
                    :rules="rules.password"
                    :type="!clearTextPassword ? 'password' : 'text'"
                    :append-icon="clearTextPassword ? 'visibility_off' : 'visibility'"
                    @click:append="clearTextPassword = !clearTextPassword"
                    required></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey"
            :disabled="loading"
            @click="shown = false"
            text
          >
            Cancel
          </v-btn>
          <v-btn color="success darken-2"
            :disabled="loading"
            :loading="loading"
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Bus } from '@/bus'
import { Rules } from '@/helpers'

export default {
  name: 'AdminDialog',
  props: {
    showEntitlementsChips: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      shown: false,
      loading: false,
      fields: {},
      admin: {},
      clearTextPassword: false,
      authenticationType: 'sso'
    }
  },
  computed: {
    /**
     * Determine if dialog openned in create mode
     */
    isCreate () {
      return !(this.admin && this.admin.id)
    },
    showPassword () {
      return this.authenticationType === 'password'
    },
    /**
     * Dialog title
     */
    title () {
      return this.isCreate
        ? 'Create Admin'
        : 'Update Admin'
    },
    /**
     * Fields rules
     */
    rules () {
      const emails = this.$store.getters['entitlements/admins']
        .filter(admin => this.isCreate || this.admin.id !== admin.id)
        .map(admin => admin.email)

      return {
        first_name: [
          ...Rules.admin.firstname
        ],
        last_name: [
          ...Rules.admin.lastname
        ],
        email: [
          (v) => emails.findIndex(email => v === email) === -1 || 'A user with this email already exists'
        ],
        password: this.showPassword && (this.fields.password || this.isCreate)
          ? Rules.account.password()
          : []
      }
    }
  },
  methods: {
    /**
     * Launch admin dialog
     */
    launch (fields) {
      this.$set(this, 'admin', fields)

      if (this.isCreate) {
        this.$set(this, 'fields', { first_name: null, last_name: null, email: null, password: null, role_id: null })
        if ('form' in this.$refs) {
          this.$refs['form'].resetValidation()
        }
      } else {
        this.$set(this, 'fields', { first_name: fields.first_name, last_name: fields.last_name, email: fields.email, password: null, role_id: parseInt(fields.role_id) })
      }
      this.$set(this, 'shown', true)
    },
    /**
     * Save admin form
     */
    save () {
      if (!this.$refs['form'].validate()) {
        return
      }

      this.$set(this, 'loading', true)

      const action = this.isCreate ? 'createAdmin' : 'updateAdmin'

      let payload = Object.assign({}, this.fields)

      if (!this.isCreate) {
        payload['id'] = this.admin.id
      }

      if (!this.showPassword || !payload['password']) {
        delete payload['password']
      }

      this.$store.dispatch(`entitlements/${action}`, payload)
        .then(() => {
          Bus.$emit('alert', { color: 'success', message: `'${payload.first_name} ${payload.last_name}' admin ${this.isCreate ? 'created' : 'updated'}` })
        })
        .catch(({ message }) => {
          Bus.$emit('alert', ({ color: 'error', message }))
        })
        .finally(() => {
          this.$set(this, 'admin', {})
          this.$set(this, 'loading', false)
          this.$set(this, 'shown', false)
        })
    },
    requiresPassword () {
      return this.showPassword && this.isCreate
    }
  }
}
</script>
